import React from 'react';
import { Container } from '../common/Container';
import logoGba from '../../assets/icons/LogoGbaMainColor.svg';
import styles from './Footer.module.css';

export const Footer: React.FC = () => {
  return (
    <footer className={styles['footer']}>
      <Container>
        <div className={styles['footer__content']}>
          <img src={logoGba} alt="Logo GBA" className={styles['footer__logo-img']} />
          <a href="https://tablero.sg.gba.gob.ar" target="_blank" rel="noopener noreferrer" title="Tablero de links para uso interno">TABLERO</a>
        </div>        
        <div className={styles['footer__copyright']}>
          Wiki © {new Date().getFullYear()} — Secretaría General
        </div>
      </Container>
    </footer>
  );
};
